import { render } from "./Image.vue?vue&type=template&id=458f33cd&scoped=true&ts=true"
import script from "./Image.vue?vue&type=script&lang=ts"
export * from "./Image.vue?vue&type=script&lang=ts"

import "./Image.vue?vue&type=style&index=0&id=458f33cd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-458f33cd"]])

export default __exports__